import StatusBar from "./StatusBar";

/**
 * @param {object} props
 * @param {string} props.tier
 * @param {{ title: string, completed: number, required: number }[]} props.bars
 * @returns {React.Component}
 */
export default function StatusBanner({ bars }) {
  return (
    <div className="flex w-full flex-col gap-2">
      {bars.map((bar) => (
        <StatusBar key={bar.title} bar={bar} />
      ))}
    </div>
  );
}
